import { FC } from "react";
import Card from "@/components/Card";
import Typography from "@/components/Typography";
import Button from "@/components/Button";
import { CloseIcon } from "@/components/Icon";
import { useFilterStatus } from "@/hooks";
import styles from "./AcademyBannerCard.module.scss";

const AcademyBannerCard: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { setIsFilterOpen } = useFilterStatus();
  return (
    <Card className={styles.root}>
      <div className={styles.topContainer}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={`/images/academy-banner.svg`}
          alt="icon"
          className={styles.bannerImage}
        />
        <Button
          size="small"
          variant="outlined"
          className={styles.button}
          onClick={() => setIsFilterOpen(true)}
        >
          Find out more
        </Button>
      </div>
      <Typography className={styles.text} variant="body2">
        Expert courses for <br />
        Global Travellers to help you learn as you travel!
      </Typography>
      <CloseIcon className={styles.closeIcon} onClick={() => onClose()} />
    </Card>
  );
};

export default AcademyBannerCard;
